import type { EbookQuestion } from '@wx-weiqi/contracts';
import { classroomRecordHistory } from './classroom-lecture';

/** A saved textbook diagram is an opening, not a played answer variation. */
export function classroomTextbookOpening(question: EbookQuestion) {
  return {
    moveNumber: 0,
    stones: question.stones,
    lastMove: null,
    color: null,
    ruleHistory: classroomRecordHistory(question.size, question.stones, question.currentPlayer, []),
  };
}
